module.exports = __webpack_public_path__ + "static/media/time.2ff0f4d1.svg";